export const SOLDEGEN_ERRORS = { 
    "ERR_NETWORK": "Solana Sucks",
    "6000": {msg: "Invalid Multiplier Length", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6001": {msg: "Invalid Multiplier", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6002": {msg: "Amount must be greater than Zero", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6003": {msg: "Game is already in progress", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6004": {msg: "Not enough SOL", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6005": {msg: "Invalid Admin", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6006": {msg: "Oracle Failed", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6007": {msg: "Paused Game", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged.", subMsg1: "Click Retry to process your bet result", subMsg2: "You will not be charged"},
    "6008": {msg: "Invalid Fee Pool", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6009": {msg: "Not enough SOL in RewardPool", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6010": {msg: "You cannot bet more than 1 SOL", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6011": {msg: "Not enough SOL for withdrawal", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"}
}

export const SPLDEGEN_ERRORS = { 
    "ERR_NETWORK": "Solana Sucks",
    "6001": {msg: "Invalid Multiplier Length", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6002": {msg: "Invalid Multiplier", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6003": {msg: "Amount must be greater than Zero", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6004": {msg: "Game is already in progress", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6005": {msg: "Not enough SOL", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6006": {msg: "Invalid Admin", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6007": {msg: "Oracle Failed", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6008": {msg: "Paused Game", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged.", subMsg1: "Click Retry to process your bet result", subMsg2: "You will not be charged"},
    "6009": {msg: "Invalid Fee Pool", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6010": {msg: "Not enough SOL in RewardPool", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6011": {msg: "Not Enough Tokens in Reward Pool", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6012": {msg: "Not enough SOL for withdrawal", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6013": {msg: "Not enough SOL for withdrawal", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6014": {msg: "Invalid SPL Token", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"},
    "6015": {msg: "Invalid SPL Range", loaderImg: "images/networkcongestion.gif", errorMsg: "Solami Rugged"}
}

export const SOL = [
    {
        "index": 0,
        "value": 1.33,
        "percentage": 75,
        "amounts": [0.05, 0.1, 0.25, 0.5, 1, 2, 3, 4]
    },
    {
        "index": 2,
        "value": 4,
        "percentage": 25,
        "amounts": [0.05, 0.1, 0.25, 0.5, 1, 2]
    },
    {
        "index": 3,
        "value": 10,
        "percentage": 10,
        "amounts": [0.05, 0.1, 0.25, 0.5, 1]
    },   
    {
        "index": 1,
        "value": 2,
        "percentage": 50,
        "amounts": [0.05, 0.1, 0.25, 0.5, 1, 2, 3, 4]
    }    
]

export const TOKENS = {
    "POGR": {
        "mint": "41wbFeKxid6e7z5wh72PYwEK8GPx5w6LmCVnwHJqacCc",
        "program_id": "6k4BnEjVB4U4uqz9ohBNz6Bv1hRzdr3SQCxo9hLk3WBC",
        "index": 9,
        "decimals": 1000000000,
        "min": 10,
        "max": 400,

        "betConstraints": [      
            {
                "index": 0,
                "value": 1.33,
                "percentage": 75,
                "amounts": [2,4,10,15,20,25]
           },  
            {   
                "index": 2,
                "value": 4,
                "percentage": 25,                
                "amounts": [2,4,6,8,10]
            },
            {   
                "index": 3,
                "value": 10,
                "percentage": 10,
                "amounts": [1,2,3,4,5]
            },
            {   
                "index": 1,
                "value": 2,
                "percentage": 50,
                "amounts": [2,4,10,15,20,25]
            }            
           
        ]
    }   
}

